import React from 'react';
import './styles.scss';

import Main from './Components/Main';

const AuditTrail = (props) => {
	return <div className="bpl-container">
		<section className={`audittrail`}>
			<div className={`top`}>
				<h3 className={`title`}>Audit Trail</h3>
			</div>
			<Main />
		</section>
	</div>
}

export default AuditTrail;